import { Card, Grid, Section } from './styles';

import CtaButton from '@/components/ui/buttons/CtaButton';
import Image from 'next/image';
import React from 'react';

type Item = {
  id: number;
  title?: string;
  content?: string;
  type: string;
  image?: string;
  imageAlt?: string;
  cta?: {
    text: string;
    url: string;
  };
};

interface GridProps {
  heading?: string;
  background?: string;
  items: Item[];
}

const GridGallery: React.FC<GridProps> = ({ heading, background, items = [] }) => {
  return (
    <Section background={background}>
      {heading && <h2 className="gallery-title">{heading}</h2>}
      <Grid>
        {items.map((item, index) => (
          <div className={`grid-item item-${item.type}`} key={item.id}>
            <Card className={`card card-${item.type}`}>
              {item.type === 'image' ? (
                <div className="card-front">
                  {item.image && (
                    <Image src={item.image} alt={item.imageAlt ?? ''} fill style={{ objectFit: 'cover' }} />
                  )}
                </div>
              ) : (
                <>
                  <div className="card-front">
                    <h2>{item.title}</h2>
                  </div>
                  <div className="card-back">
                    <h2>{item.title}</h2>
                    <p>{item.content}</p>
                    {item.cta && item.cta.text && (
                      <div className="item-cta">
                        <CtaButton
                          to={item.cta.url}
                          type="link"
                          hoverMode={index > 0 && index % 2 !== 0 ? 'light' : 'dark'}
                          aria-label={`${item.cta.text} about ${item.title}`}
                        >
                          {item.cta.text}
                        </CtaButton>
                      </div>
                    )}
                  </div>
                </>
              )}
            </Card>
          </div>
        ))}
      </Grid>
    </Section>
  );
};

export default GridGallery;
